/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type TsPersonCategoryType = typeof TsPersonCategoryType[keyof typeof TsPersonCategoryType];


export const TsPersonCategoryType = {
  Person: 'Person',
  Anspechpartner: 'Anspechpartner',
  AuthorOrComposer: 'AuthorOrComposer',
  WorkTeam: 'WorkTeam',
  HostFamily: 'HostFamily',
  Firmen: 'Firmen',
  Agentur: 'Agentur',
  Theater: 'Theater',
  Hotel: 'Hotel',
  SonstigeFirmen: 'SonstigeFirmen',
  Veranstalter: 'Veranstalter',
  Verlag: 'Verlag',
  TaxOfficeNote: 'TaxOfficeNote',
  HealthInsurance: 'HealthInsurance',
  Supplier: 'Supplier',
  Orchester: 'Orchester',
  Chor: 'Chor',
  Ballett: 'Ballett',
  Statisterie: 'Statisterie',
} as const;
